import React from 'react';
import messages from 'configShared/messages/en';
import { TMsg } from 'appTypes/messages';

export const ContextMessages = React.createContext<TMsg>(messages);

export default {
  ContextMessages,
};
